import { styled, IconButton, DialogTitle } from '@mui/material';

const CustomTitle = styled(DialogTitle)({
    paddingRight: '2rem',
    color: 'rgba(0, 0, 0, 0.87)',
    fontWeight: '400',
    fontStyle: 'normal',
    padding: '0.5rem',
    lineHeight: '160%',
    letterSpacing: '0.15px',
    '& .MuiTypography-root': {
        fontSize: '20px',
        color: 'rgba(0, 0, 0, 0.87)',
        fontWeight: '400',
        marginLeft: '0',
    },
});

const CloseIconButton = styled(IconButton)({
    zIndex: 2,
    position: 'absolute',
    right: '0.5rem',
    color: 'rgba(0, 0, 0, 0.56)',
    marginTop: '0.3rem',
});

export { CustomTitle, CloseIconButton };
